import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminPortalRoutingModule } from './admin-portal-routing.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NotificationModule } from '../notification.module';
import { NotificationService } from '../service/notification.service';
import { MaterialModule } from '../material/material.module';
import { HomeModule } from '../home/home.module';
import { ApprovalFlowComponent } from './approval-flow/approval-flow.component';
import { ManageApprovalComponent } from './manage-approval/manage-approval.component';
import { AdjustmentsApprovalComponent } from './adjustments-approval/adjustments-approval.component';
import { TicketApprovalsComponent } from './ticket-approvals/ticket-approvals.component';
import { TicketProcessComponent } from './ticket-process/ticket-process.component';
import { EmployeeDocumentComponent } from './employee-document/employee-document.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TicketPendingComponent } from './ticket-pending/ticket-pending.component';
import { ApprovalsComponent } from './approvals/approvals.component';
import { CommissionReportPreviewModalComponent } from './approvals/comm-preview-modal/comm-preview-modal.component';


@NgModule({
  declarations: [
    ApprovalFlowComponent,
    ManageApprovalComponent,
    AdjustmentsApprovalComponent,
    TicketApprovalsComponent,
    TicketProcessComponent,
    EmployeeDocumentComponent,
    TicketPendingComponent,
    ApprovalsComponent,
    CommissionReportPreviewModalComponent
  ],
  imports: [
    CommonModule,
    AdminPortalRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationModule,
    MaterialModule,
    PdfViewerModule
  ],
  providers: [NotificationService]
})
export class AdminPortalModule { }